import { Box, Divider, SxProps, Theme, Typography } from '@mui/material';
import type { CommonPageForm } from 'modules/pages/pages/page-builder-v2/page-builder-v2.types';
import { FC } from 'react';

import { ProductImage } from '../product-image/product-image';
import { styles } from './product-selector.styles';

interface IProductSelectorProps {
  products: CommonPageForm['products'];
  selectedId: string | null;
  onSelect: (id: string) => void;
  cardsVisible: boolean;
}

export const ProductSelector: FC<IProductSelectorProps> = ({ cardsVisible, onSelect, products, selectedId }) => {
  if (!products || products.length === 0) return null;
  if (cardsVisible) return null;

  return (
    <Box sx={styles.stickyContainer}>
      <Divider sx={styles.divider}>
        <Typography color="text.secondary" sx={styles.dividerText} variant="caption">
          Product Details Configuration
        </Typography>
      </Divider>

      <Box sx={styles.selectorWrapper}>
        {products.map((product, index) => {
          const productIdStr = String(product.product_id);
          const isActive = productIdStr === selectedId;
          const isBestPick = index === 0;
          const hasSticker = !!product.value;

          return (
            <Box
              key={productIdStr}
              onClick={() => onSelect(productIdStr)}
              sx={[styles.selectorItem, isActive && styles.selectorItemActive] as SxProps<Theme>}
            >
              <ProductImage
                alt={product.title}
                src={product.imgMedium || product.imgLarge}
                sx={styles.selectorImage}
              />
              <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
                {hasSticker && (
                  <Typography
                    color={isBestPick ? 'primary.main' : 'text.secondary'}
                    fontWeight="bold"
                    sx={styles.stickerText}
                    variant="caption"
                  >
                    {isBestPick ? '★ ' : ''}
                    {product.value}
                  </Typography>
                )}

                <Typography
                  color={isActive ? 'primary.dark' : 'text.primary'}
                  sx={styles.selectorText}
                >
                  {product.subtitle || product.title}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
